window.qtee.customDesign = window.qtee.customDesign || {};

const { qtee } = window;

qtee.customDesign.NewDesignView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/design-new',
	clicked: false,
	currPage: 0,
	ui: {
		designSlider: '.designSlider',
		oneDesign: '.oneDesign',
		designBack: '.back',
		naviNumbers: '#naviNumbers a',
		prev: '#prevNum',
		next: '#nextNum'
	},
	events: {
		'click @ui.oneDesign:not(.disabled)': 'addDesignClick',
		'mousedown @ui.oneDesign:not(.disabled)': 'savePatternId',
		'keypress @ui.designBack': 'designBackEnter',
		'keypress @ui.oneDesign:not(.disabled)': 'oneDesignEnter',
		'click @ui.naviNumbers': 'addTabIndex',
		'keypress @ui.prev': 'addTabIndex',
		'keypress @ui.next': 'addTabIndex',
		'mousedown @ui.prev': 'addTabIndex',
		'mousedown @ui.next': 'addTabIndex',
		'click @ui.designBack': 'backClick'
	},
	initialize (opts) {

		this.$events = $(qtee.customDesign);
		this.customModel = opts.customModel;
		this.isPillow = opts.isPillow;
		this.viewState = {
			patternId: null
		};

	},
	templateHelpers () {

		return {
			maxReached: this.customModel.elements.pattern.length >= qtee.customDesign.settings.limits.design,
			preview: qtee.customDesign.settings.designs.preview
		};

	},
	onDomRefresh () {

		this.setupView();
		this.addTabIndex(null, 1);

	},
	designBackEnter (e) {

		if (e.key === 'Enter') {

			this.backClick();
			return false;

		}
		return true;

	},
	oneDesignEnter (e) {

		if (e.key === 'Enter') {

			this.savePatternId(e);
			this.addDesignClick(e);
			return false;

		}
		return true;

	},

	addTabIndex (e, pageNum) {

		// pageNum value is 1 when this method is called from onDomRefresh()
		if (pageNum != 1) {

			const val = $(e.target).attr('val');
			if (val == 'prev') {

				pageNum = parseInt(this.currPage) - 1;
				if (e.key === 'Enter') {

					$('#prevNum').click();

				}

			} else if (val == 'next') {

				pageNum = parseInt(this.currPage) + 1;
				if (e.key === 'Enter') {

					$('#nextNum').click();

				}

			} else {

				pageNum = parseInt(val) + 1;

			}

		}

		this.currPage = pageNum;
		const startVal = (pageNum - 1) * 12;
		const endVal = pageNum * 12;
		// Remove the tab index for all Carets
		$('.oneDesign').removeAttr('tabindex');
		// Add tabindex to selected caret section
		for (i = startVal; i < endVal; i++) {

			$(`.oneDesign[data-id='${i}']`).attr('tabindex', '0');

		}

	},

	setupView (e, opts) {

		const that = this;

		that.ui.designSlider.scrollable({ touch: true });
		that.ui.designSlider.navigator();
		$('#naviNumbers').find('a').attr('href', ' ');
		// Get all anchor tags which are child to #navNumber div tag
		// then add val attribute with index value to all anchor tags
		const { length } = $('#naviNumbers').find('a');
		for (i = 0; i < length; i++) {

			$(`#naviNumbers a:eq(${i})`).attr('val', parseInt(i));

		}

		if (opts && opts.slide) {

			that.ui.designSlider.scrollable().move(opts.slide);

		}

	},

	savePatternId (e) {

		const target = e.target.tagName === 'IMG' ? $(e.target).parent('.oneDesign') : $(e.target);
		this.viewState.patternId = target.data('id');

	},

	/** Add new design */
	addDesignClick (e, drag) {

		if (this.clicked) {

			return;

		}

		this.clicked = true;

		const that = this;
		const id = this.viewState.patternId;
		const pattern = qtee.customDesign.availablePatterns.get('patterns')[parseInt(id, 10)];
		// loader
		const stopLoader = this.$events.triggerHandler('startLoader');
		const skipAdd =			(document.referrer.search('/cart/') > -1 || document.referrer.search('/wish-list/') > -1)
			&& qtee.customDesign.sceneLoaded
			&& !qtee.customDesign.sceneCloned;

		// model and svg-element should be created in synchronous way
		// since we dont know the actual size of pattern/desing element on front-end until we got it from server
		// note the qtee.customDesign.settings.newEl.design.width (height) below are maximum values for width (height)

		let OriginY = that.customModel.area.Height / 2;
		if (drag) {

			if (e.offsetY >= 0) {

				OriginY = e.offsetY;

			} else {

				OriginY = 0;

			}

		}
		const model = that.customModel.elements.pattern.create(
			{
				OriginX: drag ? e.offsetX : that.customModel.area.Width / 2,
				OriginY,
				PatternId: pattern.PatternId,
				Scale: qtee.customDesign.settings.newEl.design.scale,
				Width: that.isPillow
					? qtee.customDesign.settings.newEl.design.width
					: qtee.customDesign.settings.newEl.designLampshade.width,
				Height: that.isPillow
					? qtee.customDesign.settings.newEl.design.height
					: qtee.customDesign.settings.newEl.designLampshade.height,
				RotationalDegree: qtee.customDesign.settings.newEl.design.rotation,
				PatternImageUrl: pattern.PatternImageUrl,
				ZOrder: qtee.customDesign.canvas.getMaxZIndex() + 1
			},
			{
				wait: false,
				success (r) {

					if (skipAdd) {

						stopLoader();
						that.$events.triggerHandler('add.history', [ [ r ] ]);
						return;

					}
					// server returned the actual size of pattern/design model
					qtee.customDesign.canvas.add(model).then(
						(el) => {

							that.canvasEl = el;
							that.$events.triggerHandler('showSuccessState', 'canvas element pattern was added');

						},
						(reason) => {

							that.$events.triggerHandler('showErrorState', reason);
							model.destroy();

						}
					);

					stopLoader();
					that.render();
					that.$events.triggerHandler('add.history', [ [ r ] ]);

				},
				error () {

					stopLoader();

				}
			}
		);

	},
	backClick () {

		$('#newDesignElement').hide();
		$('.restartUndoGroup').addClass('active');
		this.$events.triggerHandler('showDefaultSection');

	}
});
